function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useCallback, useEffect, useState } from 'react';
import omit from 'lodash.omit';
import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
import { buildService } from '@rd-web-markets/shared/dist/services/service';
const competentProfessionalsApi = buildService('/companies/{id}/competent_professionals', {
  only: ['all', 'delete']
}, {
  only: ['postFormData', 'putFormData']
});
const projectLevelApi = buildService('/claim_project_reports/{id}/competent_professionals', {
  only: ['all', 'delete']
}, {
  only: ['postFormData', 'putFormData']
});
const competentProfessionalProjectApi = buildService('/claim_project_reports/{id}/competent_professional_claim_project_reports', {
  only: ['update']
});
export function useProjectCompetentProfessionalService(companyId, rowData, setData, data, removeEmptyRow, emptyRowId) {
  let selectedProjectId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
  const [body, setBody] = useState(() => {
    if (!rowData.id) {
      return _objectSpread(_objectSpread({}, rowData), {}, {
        competent_professional_claim_project_reports: rowData.competent_professional_claim_project_reports || [{
          claim_project_report_id: selectedProjectId,
          exclude_from_rnd_report: true,
          review_narrative: false,
          notes: null
        }]
      });
    }
    return _objectSpread({}, rowData);
  });
  useEffect(() => {
    if (rowData.id) {
      setBody(_objectSpread({}, rowData));
    }
  }, [rowData]);
  const addData = useCallback((response, data) => {
    setData([...data, response]);
    setBody(_objectSpread({}, rowData));
  }, [rowData, setData]);
  const updateData = useCallback((response, documentOnly, data) => {
    const selectedDataIndex = data.findIndex(n => n.id === Number(body.id));
    if (documentOnly) {
      data[selectedDataIndex].document = _objectSpread({}, response.document);
    } else {
      data[selectedDataIndex] = _objectSpread({}, response);
    }
    setData([...data]);
  }, [body.id, setData]);
  const saveData = useErrorHandling(useCallback(async body => {
    let fieldValues = omit(body, ['id', 'created_at', 'updated_at', 'claim_project_report_id']);
    const fd = new FormData();
    fd.append('competent_professional', JSON.stringify(_objectSpread({}, fieldValues)));
    let response = null;
    if (selectedProjectId) {
      const competentProfessionalProjectIndex = body.competent_professional_claim_project_reports.findIndex(r => r.claim_project_report_id === Number(selectedProjectId));
      const competentProfessionalProjectBody = body.competent_professional_claim_project_reports[competentProfessionalProjectIndex];
      await competentProfessionalProjectApi.update(selectedProjectId, competentProfessionalProjectBody.id, competentProfessionalProjectBody);
      response = await projectLevelApi.putFormData(selectedProjectId, body.id, fd);
    } else {
      response = await competentProfessionalsApi.putFormData(companyId, body.id, fd);
    }
    updateData(response, false, data);
  }, [selectedProjectId, updateData, data, companyId]));
  const createNewData = useErrorHandling(useCallback(async formData => {
    let fieldValues = omit(body, ['id', 'created_at', 'updated_at', 'claim_project_report_id']);
    formData.append('competent_professional', JSON.stringify(_objectSpread(_objectSpread({}, fieldValues), {}, {
      company_id: companyId
    })));
    let response = null;
    if (body.claim_project_report_id) {
      response = await projectLevelApi.postFormData(body.claim_project_report_id, formData);
    } else {
      response = await competentProfessionalsApi.postFormData(companyId, formData);
    }
    addData(response, data);
    removeEmptyRow(emptyRowId);
  }, [body, addData, data, removeEmptyRow, emptyRowId, companyId]));
  const deleteData = useErrorHandling(useCallback(async (body, data, selectedProjectId) => {
    if (selectedProjectId) {
      await projectLevelApi.delete(selectedProjectId, body.id);
    } else {
      await competentProfessionalsApi.delete(companyId, body.id);
    }
    const deletedNameListIndex = data.findIndex(n => n.id === Number(body.id));
    data.splice(deletedNameListIndex, 1);
    setData([...data]);
  }, [companyId, setData]));
  return [saveData, createNewData, deleteData, body, setBody];
}